import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row,
    Card
} from "reactstrap";
import styles from './styles.module.scss';
import Link from "next/link"
import Mail from '/public/site-assets/svg/mail.svg';
import LinkedIn from '/public/site-assets/svg/linkedin.svg';

export default function AllConsultants({
    global,
    pathPrefix,
    all_consultant,
    customClass = "",
    buttonTitle
}) {

    return (
        all_consultant.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    <Row>
                        {all_consultant?.map((post, index) => (
                            <Col xs={12} md={6} lg={4} xl={3} className="mb-4" key={index}>
                                <Card className="consultant p-5 pb-4 rounded-3 border text-center h-100 justify-content-between">
                                    <span className="contact position-absolute d-flex flex-wrap">
                                        {post?.email ?
                                            <Link href={`mailto:${post.email}`}>
                                                <a className="text-decoration-none w-100 mb-1">
                                                    <Mail />
                                                </a>
                                            </Link> : ""}
                                        {post?.linkedin ?
                                            <Link href={`${post.linkedin}`}>
                                                <a className="text-decoration-none w-100 mb-1" target="_blank" rel="noopener noreferrer">
                                                    <LinkedIn />
                                                </a>
                                            </Link> : ""}
                                    </span>
                                    <Link href={`/meet-the-team/${post.url_slug}/`}>
                                        <a className="text-decoration-none">
                                            <SourceFlowImage
                                                src={post?.image ? post.image : "/site-assets/images/image-placeholder.webp"}
                                                size="800x800"
                                                alt={post.name}
                                                className="card-img overflow-hidden"
                                                width="100%"
                                                height="100%"
                                            />
                                        </a>
                                    </Link>
                                    {post?.name ?
                                        <h5 className="name mt-4">{post.name}</h5> : ""}
                                    {post?.position ?
                                        <div><small>{post.position}</small></div> : ""}
                                    <div className="mt-4">
                                        <Link href={`/meet-the-team/${post.url_slug}/`}>
                                            <a className="text-decoration-none">
                                                <span className="primaryBtn">
                                                    <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                                                        {buttonTitle}
                                                    </SourceFlowText>
                                                </span>
                                            </a>
                                        </Link>
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        )
    )
}